import { createContext } from 'react';

import { Dispatch, Action } from 'redux';

import {
  UserDashboards,
  WidgetItem,
  Team,
  LocationAndTeamsFilterState,
  ChatUser,
} from '@vyce/core/src/types';
import { WidgetWrapperProps } from '../components/Dashboard/WidgetWrapper';

interface Context {
  dashboards?: UserDashboards;
  first_name: string;
  teams?: Team[];
  companyDataLoading: boolean;
  selectedCompanyId: string;
  timePermission: boolean;
  teamPermission: boolean;
  mainDashboardFilters: LocationAndTeamsFilterState | undefined;
  updateMainDashboardFilters: (filters: LocationAndTeamsFilterState) => void;
  widgetComponent: (props: { widget: WidgetItem; redirectUrl?: string } & WidgetWrapperProps) => JSX.Element;
  inviteButtonComponent?: () => JSX.Element;
  updateUserDashboards: (dashboards: UserDashboards) => (dispatch: Dispatch<Action>) => Promise<void>;
  onOpenUniversalInviteForm?: () => void;
  chatUser?: ChatUser;
}

export const TeamsDashboardModuleContext = createContext({} as Context);

export const TeamsDashboardModuleProvider = TeamsDashboardModuleContext.Provider;
